import { useState, useEffect, RefObject } from 'react';

const listeners = new Map<Element, (visible: boolean) => void>();
let observer: IntersectionObserver | undefined;

export function useSkeletonVisibility(ref: RefObject<HTMLElement>, enabled: boolean) {
  const [isVisible, setIsVisible] = useState(() => typeof IntersectionObserver === 'undefined');

  useEffect(() => {
    const element = ref.current;

    if (!enabled || !element) {
      return undefined;
    }

    if (typeof IntersectionObserver === 'undefined') {
      setIsVisible(true);
      return undefined;
    }

    if (!observer) {
      observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => listeners.get(entry.target)?.(entry.isIntersecting));
      });
    }

    listeners.set(element, setIsVisible);
    observer.observe(element);

    return () => {
      observer?.unobserve(element);
      listeners.delete(element);

      if (listeners.size === 0) {
        observer?.disconnect();
        observer = undefined;
      }
    };
  }, [enabled, ref]);

  return isVisible;
}
